module.exports = __webpack_public_path__ + "static/img/quirky-clock-dark.f1c54823.svg";